import React from "react";
import HyvidAwardsTab from "./components/HyvidAwardsTab";
import ShortHeaderComponent from "./components/ShortHeaderComponent";
import { useNavigate, useLocation } from "react-router-dom";
import { displayIcon } from "variables/icons";

const HyvidAwards = () => {
      const navigate = useNavigate();
      const location = useLocation();
  
      const navFromQuickAccess = location.state?.fromQuickAccess;
  return (
    <div>
       {navFromQuickAccess && (
          <button
              onClick={() => navigate("/console/dashboard")}
              className="flex items-center border rounded-xl px-2 py-1 gap-2 dark:text-white mb-4"
          >
              {displayIcon('ArrowLeft', 'w-4 h-4 dark:text-white')}
              Back to Dashboard
          </button>
        )}
      <div className="flex flex-col gap-6">
        
        <ShortHeaderComponent
          icon="Award"
          title="Rewards & Recognition"
          description="Nominate exceptional team members for awards and celebrate achievements"
        />
        <HyvidAwardsTab/>
      </div>
    </div>
    
  );
};



export default HyvidAwards;
